import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { Table, Select, Button, Drawer } from "antd";
import Search from "antd/es/input/Search";
import PageTitle from "../Common/PageTitle";
import { formatOptionLabel } from "../../common/elements/myCustomSelect";
import useSWRImmutable from "swr/immutable";
import { fetcher, fetcherhn } from "../../services/fectcher";
import useSWR from "swr";
import dayjs from "dayjs";
import { FaCalendarAlt } from "react-icons/fa";
import MyBackdropSpinner from "../../common/elements/myBackdropSpinner";
import VisitTrackingForm from "./VisitTrackingForm";
import { usePickList } from "../../services/queries";

const PatientStatus = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Active",
    label: "Active",
  },
  {
    value: "Deceased",
    label: "Deceased",
  },
  {
    value: "Dealigned",
    label: "Dealigned",
  },
];

const currentYearString = dayjs().year().toString();

const VisitTrackingHome = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const navigateType = useNavigationType();

  const [year, setYear] = useState(currentYearString);
  const [provider, setProvider] = useState("");
  const [cmsProvider, setCMSProvider] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [status, setStatus] = useState("Active");

  const {
    data: tableData,
    mutate,
    isLoading: tableDataLoading,
  } = useSWR(
    `getPatientCceRecords?providerGroup=All&Provider=${
      provider || "All"
    }&allignedProvider=${
      cmsProvider || "All"
    }&cmsProvider=All&patientStatus=${status}&performyr=${year}`,
    fetcherhn
  );

  const { data: provList } = useSWRImmutable(
    `getccmdproviders?lob=HN`,
    fetcher
  );

  const { data: provcoderList } = useSWRImmutable(
    `GetNpPaList?nppa_for=CODERWORKFLOW`,
    fetcherhn
  );
  const { data: cmsProvList } = useSWRImmutable(`getAlignedProvider`, fetcher);

  const { data: alignmentYear } = useSWRImmutable(`GetPerformYr`, fetcherhn);

  const transformedData = alignmentYear?.map((item) => ({
    label: item?.performyr?.toString(),
    value: item?.performyr?.toString(),
  }));

  const onProviderChange = (e) => {
    setProvider(e);
  };

  const onCMSProviderChange = (e) => {
    setCMSProvider(e);
  };

  useEffect(() => {
    if (location.state?.query) {
      setQuery(location.state.query);
    }
    if (location.state?.page) {
      setPage(location.state.page);
    }
    if (location.state?.pageSize) {
      setPageSize(location.state.pageSize);
    }

    if (location.state?.provider) {
      const providerOption = provList?.find(
        (option) => option.label === location.state.provider
      );
      setProvider(providerOption ? providerOption.value : null);
    } else {
      setProvider(null);
    }
    if (location.state?.cmsProvider) {
      const cmsProviderOption = cmsProvList?.find(
        (option) => option.label === location.state.cmsProvider
      );
      setCMSProvider(cmsProviderOption ? cmsProviderOption.value : null);
    } else {
      setCMSProvider(null);
    }

    if (location.state?.status) {
      const statusOption = PatientStatus?.find(
        (option) => option.label === location.state.status
      );
      setStatus(statusOption ? statusOption.value : null);
    } else {
      setStatus("Active");
    }

    if (location.state?.year) {
      const yearOption = transformedData?.find(
        (option) => option.label === location.state.year
      );
      setYear(yearOption ? yearOption?.value : null);
    } else {
      setYear(currentYearString);
    }

    if (navigateType === "POP") {
      setStatus("Active");
      setYear(currentYearString);
      setQuery("");
      setPage(1);
      setPageSize(10);
    }
  }, [location.state, navigateType]);

  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patientNamewithDOB",
      width: 400,
      render: (text, record) => {
        // let statusColor = "tw-text-red-600"; // Default to red (Coder Review Not Started)
        // let statusMessage = "(Coder Review Not Started)";

        // if (record?.currentStatus === "Completed") {
        //   statusColor = "tw-text-green-600";
        //   statusMessage = "(Coder Review Completed)";
        // } else if (record?.currentStatus === "Started") {
        //   statusColor = "tw-text-blue-600";
        //   statusMessage = "(Coder Review in Process)";
        // } else if (record?.currentStatus === "Followup") {
        //   statusColor = "tw-text-gray-600";
        //   statusMessage = "(Follow Up Review)";
        // }

        return (
          <>
            <div className="tw-font-medium">
              {formatOptionLabel({ label: record?.patientNamewithDOB })}
            </div>
            <div className="tw-font-medium tw-text-gray-600">{record.mbi}</div>
            {record.gender === "Male" ? (
              <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
                {record.age} / M
              </p>
            ) : (
              <p className="tw-font-medium tw-mb-0 tw-text-gray-500">
                {record.age} / F
              </p>
            )}
            {/* <p className={`tw-mb-0 ${statusColor}`}>{statusMessage}</p> */}
          </>
        );
      },
    },
    {
      title: "CCMD Provider / Group",
      dataIndex: "ccmdProvider",
      width: 200,
      render: (text, record) => (
        <>
          <div>{record.ccmdProvider}</div>
          <div className="tw-text-gray-600">{record.providerGroup}</div>
        </>
      ),
    },
    {
      title: "CMS Provider / Group",
      dataIndex: "alignedProvider",
      width: 200,
      render: (text, record) => (
        <>
          <div>{record.alignedProvider}</div>
          <div className="tw-text-gray-600">
            {record.cmsAllignedProviderGroup}
          </div>
        </>
      ),
    },
    {
      title: "Visit Type",
      dataIndex: "visitTypeLabel",
      render: (text, record) => {
        let displayText = text;

        if (record.deceasedDate && dayjs(record.deceasedDate).isValid()) {
          displayText = "";
        }

        return (
          <>
            <div>{displayText}</div>
          </>
        );
      },
    },
    {
      title: "Visit Status",
      dataIndex: "visitStatusLabel",
      width: 200,
      render: (text, record) => {
        let formattedDate = "";

        if (record.deceasedDate && dayjs(record.deceasedDate).isValid()) {
          formattedDate = dayjs(record.deceasedDate).format("YYYY-MM-DD");
          text = "Deceased";
        } else if (
          record.visitStatusScheduledDate &&
          dayjs(record.visitStatusScheduledDate).isValid()
        ) {
          const tempDate = dayjs(record.visitStatusScheduledDate).format(
            "YYYY-MM-DD"
          );
          formattedDate = tempDate === "1900-01-01 12:00 AM" ? "" : tempDate;
        }

        return (
          <div>
            <div>{text}</div>
            {formattedDate && (
              <div className="tw-flex tw-items-center tw-space-x-2 tw-text-gray-600">
                <FaCalendarAlt size={16} className="tw-align-middle " />
                <p className="tw-mb-0">{formattedDate}</p>
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Scheduling Details",
      dataIndex: "schedulingDetailsLabel",
      render: (text, record) => {
        let formattedDate = "";
        if (
          record.schedulingDetailDate &&
          dayjs(record.schedulingDetailDate).isValid()
        ) {
          const tempDate = dayjs(record.schedulingDetailDate).format(
            "YYYY-MM-DD"
          );
          formattedDate = tempDate === "1900-01-01" ? "" : tempDate;
        }

        return (
          <>
            <div>{text}</div>
            {formattedDate && (
              <div className="tw-flex tw-items-center tw-space-x-2 tw-text-gray-600">
                <FaCalendarAlt size={16} className="tw-align-middle" />
                <p className="tw-mb-0">{formattedDate}</p>
              </div>
            )}
          </>
        );
      },
    },
    {
      title: "Notes",
      dataIndex: "notes",
    },
  ];

  const finalResult = tableData
    ? tableData
        .filter((item) => {
          return [
            "patientNamewithDOB",
            "mbi",
            "ccmdProvider",
            "providerGroup",
            "alignedProvider",
            "cmsAllignedProviderGroup",
            "visitTypeLabel",
            "visitStatusLabel",
            "visitStatusScheduledDate",
            "schedulingDetailsLabel",
            "schedulingDetailDate",
            "notes",
          ].some((key) =>
            (
              item[key]?.toString()?.toLowerCase().replace(/_/g, " ") ?? ""
            ).includes(query?.toLowerCase().replace(/_/g, " ") ?? "")
          );
        })
        .map((item) => ({
          ...item,
          key: item.mbi || item.id || `${item.patientNamewithDOB}-${item.age}`,
        }))
    : tableData;

  const handlePageChange = (page, pageSize) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const onYearChange = (e) => {
    setYear(e);
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedMBIs, setSelectedMBIs] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedMBIs(newSelectedRowKeys); // Since we are using mbi as key
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const [openDrawer, setOpenDrawer] = useState(false);

  const schedulingDetailOptions = usePickList(50)?.data;
  const visitTypeOptions = usePickList(51)?.data;
  const statusOptions = usePickList(52)?.data;

  const initialReqState = {
    key: "",
    guid: "",
    mbi: "",
    performyr: location?.state?.year,
    visitTypeLabel: "",
    visitTypeValue: "",
    visitTypeOther: "",
    visitStatusLabel: "",
    visitStatusValue: "",
    visitStatusOther: "",
    visitStatusScheduledDate: "",
    schedulingDetailsLabel: "",
    schedulingDetailsValue: "",
    schedulingDetailDate: "",
    providerType: "",
    notes: "",
    claimType: "",
    visitLocation: "",
    renderProvider: "",
    lastUpdatedDate: "",
    createdBy: sessionStorage?.getItem("userName") || "",
    modifiedBy: "",
  };

  const [editRecord, setEditRecord] = useState(initialReqState);

  const handleCancel = () => {
    setOpenDrawer(false);
    setEditRecord(initialReqState);
  };

  const handleOk = async (e) => {
    setOpenDrawer(false);
    setSelectedMBIs([]);
    setSelectedRowKeys([]);
    mutate();
  };

  return (
    <>
      <div className="tw-flex tw-justify-between">
        <PageTitle title="Visit Tracking" />
        <div className="tw-flex tw-space-x-2 ">
          {selectedMBIs.length > 0 && (
            <Button type="primary" onClick={() => setOpenDrawer(true)}>
              Bulk Update
            </Button>
          )}

          <Select
            className="tw-w-full"
            disabled={selectedMBIs.length > 0}
            showSearch
            allowClear
            placeholder="Select Performance Year..."
            optionFilterProp="children"
            value={year}
            onChange={onYearChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={transformedData}
          />
          <Select
            className="tw-w-full"
            showSearch
            allowClear
            disabled={cmsProvider || selectedMBIs.length > 0}
            placeholder="Select CCMD Provider..."
            optionFilterProp="children"
            value={provider ?? null}
            onChange={onProviderChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={provList}
          />

          <Select
            className="tw-w-full"
            showSearch
            allowClear
            disabled={provider || selectedMBIs.length > 0}
            placeholder="Select CMS Provider..."
            optionFilterProp="children"
            value={cmsProvider ?? null}
            onChange={onCMSProviderChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={cmsProvList}
          />

          <Search
            size="middle"
            placeholder="Search"
            value={query}
            allowClear
            onChange={(e) => setQuery(e.target.value)}
          />
          <Select
            className="tw-w-full"
            showSearch
            disabled={selectedMBIs.length > 0}
            placeholder="Active"
            optionFilterProp="children"
            defaultValue={PatientStatus[1].value}
            value={status}
            onChange={(e) => setStatus(e)}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={PatientStatus}
          />
        </div>
      </div>

      {tableDataLoading ? (
        <MyBackdropSpinner show={tableDataLoading} />
      ) : (
        <Table
          columns={columns}
          rowSelection={rowSelection}
          scroll={{ x: 1500 }}
          dataSource={finalResult}
          pagination={{
            current: page,
            pageSize: pageSize,
            onChange: (page, pageSize) => handlePageChange(page, pageSize),
            showTotal: (total, [from, to]) =>
              `Showing ${from} - ${to} of ${total} items`,
          }}
          onRow={(record) => ({
            className: "tw-cursor-pointer",
            onClick: () => {
              navigate(`/taskmanagement/visittracking/patient/${record?.mbi}`, {
                state: {
                  patientData: record,
                  query,
                  page,
                  provider,
                  cmsProvider,
                  status,
                  pageSize,
                  year,
                },
              });
            },
          })}
        />
      )}

      {openDrawer && (
        <Drawer
          open={openDrawer}
          title="Add/Update Visit Tracking"
          onClose={handleCancel}
          width={600}
        >
          <VisitTrackingForm
            visitTypeOptions={visitTypeOptions}
            statusOptions={statusOptions}
            schedulingDetailOptions={schedulingDetailOptions}
            editRecord={editRecord}
            provList={provcoderList}
            performanceYear={year}
            fromHome={true}
            selectedMBIs={selectedMBIs}
            callback={handleOk}
          />
        </Drawer>
      )}
    </>
  );
};

export default VisitTrackingHome;
